import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import { useContext, useEffect, useState } from "react";
import { TextEditorContext } from "../../../context/TextEditorContext";
import { SelectedElementContex } from "../../../context/SelectedElement";

// export default function ToogleGroupSelectedText({
//   value = "",
//   options,
// }) {
//     const { applyStyleToSelection } = useContext(TextEditorContext);
//     const { selectedElement } = useContext(SelectedElementContex);

//   return (
//     <div className="flex flex-col">
//       <ToggleButtonGroup
//         value={value}
//         exclusive
//         onMouseDown={(e) => e.preventDefault()}
//         onChange={(event, newValue) => applyStyleToSelection(newValue, selectedElement)}
//         aria-label="text alignment"
//       >
//         {options.map((option, index) => (
//           <ToggleButton title={option?.title} key={index} value={option?.value}>
//             {option?.icon}
//             {/* <FormatAlignLeftIcon /> */}
//           </ToggleButton>
//         ))}
//       </ToggleButtonGroup>
//     </div>
//   );
// }

// export default function ToogleGroupSelectedText({ options }) {
//   const { applyStyleToSelection, getAppliedStyles } = useContext(TextEditorContext);
//   const { selectedElement } = useContext(SelectedElementContex);

//   return (
//     <div className="flex flex-col">
//       <ToggleButtonGroup
//         value={null}
//         exclusive
//         onMouseDown={(e) => e.preventDefault()}
//         onChange={(event, newValue) => {
//           // ✅ FIX: Check if newValue is valid before applying
//           if (newValue && typeof newValue === 'object' && !Array.isArray(newValue)) {
//             applyStyleToSelection(newValue, selectedElement);
//           }
//         }}
//         aria-label="text alignment"
//       >
//         {options.map((option, index) => (
//           <ToggleButton
//             title={option?.title}
//             key={index}
//             value={option?.value}
//           >
//             {option?.icon}
//           </ToggleButton>
//         ))}
//       </ToggleButtonGroup>
//     </div>
//   );
// }

export default function ToogleGroupSelectedText({ options }) {
  const { applyStyleToSelection, getAppliedStyles } =
    useContext(TextEditorContext);
  const { selectedElement } = useContext(SelectedElementContex);
  const [activeStyles, setActiveStyles] = useState([]);

  // ✅ Check active styles whenever selection changes
  useEffect(() => {
    const checkStyles = () => {
      if (!getAppliedStyles) return;

      const currentStyles = getAppliedStyles();
      const active = [];

      options.forEach((option) => {
        const styleKey = Object.keys(option.value)[0];
        const styleValue = option.value[styleKey];

        // Check if this style is currently applied
        if (
          styleKey === "fontWeight" &&
          currentStyles.fontWeight === "bold" &&
          styleValue === "bold"
        ) {
          active.push(JSON.stringify(option.value));
        } else if (
          styleKey === "fontStyle" &&
          currentStyles.fontStyle === styleValue
        ) {
          active.push(JSON.stringify(option.value));
        } else if (
          styleKey === "textDecoration" &&
          currentStyles.textDecoration?.includes(styleValue)
        ) {
          active.push(JSON.stringify(option.value));
        } else if (
          styleKey === "backgroundColor" &&
          currentStyles.backgroundColor === styleValue
        ) {
          active.push(JSON.stringify(option.value));
        }
      });

      setActiveStyles(active);
    };

    checkStyles();
  }, [selectedElement, getAppliedStyles, options]);

  const handleChange = (event, newValue) => {
    // ✅ Check if newValue is valid before applying
    if (newValue && typeof newValue === "object" && !Array.isArray(newValue)) {
      applyStyleToSelection(newValue, selectedElement);
      // Recheck styles after a short delay
      setTimeout(() => {
        if (getAppliedStyles) {
          const currentStyles = getAppliedStyles();
          const active = [];
          options.forEach((option) => {
            const styleKey = Object.keys(option.value)[0];
            const styleValue = option.value[styleKey];
            if (
              styleKey === "fontWeight" &&
              currentStyles.fontWeight === "bold" &&
              styleValue === "bold"
            ) {
              active.push(JSON.stringify(option.value));
            } else if (
              styleKey === "fontStyle" &&
              currentStyles.fontStyle === styleValue
            ) {
              active.push(JSON.stringify(option.value));
            } else if (
              styleKey === "textDecoration" &&
              currentStyles.textDecoration?.includes(styleValue)
            ) {
              active.push(JSON.stringify(option.value));
            } else if (
              styleKey === "backgroundColor" &&
              currentStyles.backgroundColor === styleValue
            ) {
              active.push(JSON.stringify(option.value));
            }
          });
          setActiveStyles(active);
        }
      }, 50);
    }
  };

  return (
    <div className="flex flex-col">
      <ToggleButtonGroup
        value={null}
        exclusive
        onMouseDown={(e) => e.preventDefault()}
        onChange={handleChange}
        aria-label="text alignment"
      >
        {options.map((option, index) => {
          const isActive = activeStyles.includes(JSON.stringify(option.value));

          return (
            <ToggleButton
              title={option?.title}
              key={index}
              value={option?.value}
              selected={isActive}
              sx={{
                backgroundColor: "transparent", // Remove group background
                "& .MuiToggleButtonGroup-grouped": {
                  border: "1px solid rgba(0, 0, 0, 0.12)",
                  "&:not(:first-of-type)": {
                    borderLeft: "1px solid rgba(0, 0, 0, 0.12)",
                  },
                },
                "& .MuiToggleButton-root": {
                  color: "#333",
                  backgroundColor: "#fff",
                  "&:hover": {
                    backgroundColor: "#f5f5f5",
                  },
                  "&.Mui-selected": {
                    backgroundColor: "#e3f2fd", // Light blue when selected
                    color: "#1976d2",
                    fontWeight: "bold",
                    "&:hover": {
                      backgroundColor: "#bbdefb",
                    },
                  },
                },
              }}
            >
              {option?.icon}
            </ToggleButton>
          );
        })}
      </ToggleButtonGroup>
    </div>
  );
}
